import React from 'react'
import BlogRecentPost from './BlogRecentPost';
import BlogFilter from './BlogFilter';
import { useEffect, useState } from "react";
import { BaseUrl } from "../../helper/BaseUrl";

export default function BlogListing({ initialData }) {

  const data = {
    breadcrumb: [
      {
        name: "Blogs & Insights",
      },
    ]
  }

  const getInitialBlogs = () => {
    if (Array.isArray(initialData)) {
      return initialData;
    }

    if (Array.isArray(initialData?.listpage)) {
      return initialData.listpage;
    }

    return [];
  };

  const [allData, setAllData] = useState(getInitialBlogs);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/blogs`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }

  return (
    <>
      <BlogRecentPost allData={allData} breadcrumb={data.breadcrumb} />
      <BlogFilter allData={allData} />
    </>
  )
}
